<template>
  <div
    class="flex flex-wrap md:!flex-nowrap flex-row items-center py-1/2 pb-0 md:pb-1/2 pt-0 md:pt-1/2 shadow-sm top-[0px] w-full bg-white relative z-50 roboto"
    :class="[isSticky ? 'sticky top-[0px]' : 'top-[0px]', activeProductTab === 'buy' ? 'no-pad' : '']"
  >
    <div class="w-full shadow-sm md:shadow-none">
      <div class="mx-auto py-1/2 w-[310px] md:w-fit md:pl-0 md:ml-2 flex items-center justify-between">
        <v-button
          position="left"
          mobile="12"
          tablet="12"
          desktop="12"
          styling="tertiary"
          textAlign="left"
          :disabled="false"
          style="margin: 0px; padding: 0;"
          @onClickEvent="handleBackButtonClick()"
        >
          <template v-slot:content>
            <span class="flex back-hover">
              <BackArrow :fill="'#00263E'"/>
              <p class="roboto text-base text-blue-dark mt-0 font-bold ml-0 leading-none">
                {{ activeProductInfo.name }}
              </p>
            </span>
          </template>
        </v-button>
        <span
          v-if="activeProductTab !== 'buy'"
          class="visible-m buy-link font-normal cursor-pointer bg-blue-default text-white rounded-full text-base"
          :class="{ 'active': activeProductTab === 'buy' }"
          @click="handleBuyButtonClick()"
          >{{ buyButtonLanguage }}</span
        >
      </div>
    </div>
    <div v-if="activeProductTab !== 'buy'" class="m-auto h-[60px] flex items-center md:h-fit" :class="productTabs === 1 && 'mobile-hide'">
      <span
        class="hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark"
        :class="{ 'active': activeProductTab === 'overview' }"
        @click="handleProductTabClick('overview')"
        >{{ globals.product_nav.overview }}</span
      >
      <span
        v-show="productContent && productContent.features"
        class="hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark"
        :class="{ 'active': activeProductTab === 'features' }"
        @click="handleProductTabClick('features')"
        >{{ globals.product_nav.features }}</span
      >
      <span
        v-show="productContent && productContent.specs"
        class="hover-link font-normal cursor-pointer mx-1/2 text-base md:text-lg text-blue-dark"
        :class="{ 'active': activeProductTab === 'specs' }"
        @click="handleProductTabClick('specs')"
        >{{ globals.product_nav.specs }}</span
      >
      <span
        v-if="activeProductTab !== 'buy'"
        class="hidden-m buy-link font-normal cursor-pointer bg-blue-default text-white mx-1 rounded-full text-base md:text-lg"
        :class="{ 'active': activeProductTab === 'buy' }"
        @click="handleBuyButtonClick()"
        >{{ buyButtonLanguage }}</span
      >
    </div>
    <div
      v-if="activeProductTab !== 'buy'"
      class="hidden visible-m fixed bottom-0 left-0 w-full bg-white flex items-center justify-center py-1/2 border-t-1 border-gray-neutral-250"
    >
      <span
        class="font-bold cursor-pointer bg-blue-default text-white mx-1 py-1 px-2 rounded-full text-lg w-4/5 text-center"
        :class="{ 'font-normal': activeProductTab === 'buy' }"
        @click="handleBuyButtonClick()"
        >{{ buyButtonLanguage }}</span
      >
    </div>
  </div>
</template>

<script>
import BackArrow from '../../../utils/icons/back-arrow';
import vButton from '../../../utils/button';
import { coreProducts } from '../../../../settings';
import { WebstoreResources } from "../../../../mixins/webstore-resources";
import SalesforceResources from "../../../../mixins/salesforce-resources";
import SegmentResources from "../../../../mixins/segment-resources";

export default {
  mixins: [
    WebstoreResources,
    SalesforceResources,
    SegmentResources,
  ],
  components: {
    BackArrow,
    vButton,
  },
  data() {
    return {
      coreProducts: coreProducts,
    }
  },
  props: {
    globals: {
      type: Object,
      required: true,
    },
    isSticky: {
      type: Boolean,
      required: false,
    },
    productContent: {
      type: Object,
      required: false,
    },
  },
  computed: {
    productTabs() {
      return 1 + (this.productContent && this.productContent.features ? 1 : 0) + (this.productContent && this.productContent.specs ? 1 : 0);
    },
  },
  methods: {
    handleBackEvent() {
      if (this.activeProductTab === 'buy') {
        if (this.coreProducts.includes(this.activeProductKey)) {
          this.setActiveProductTab('overview')
        } else {
          this.backToWebstoreHome()
        }
      } else {
        this.backToWebstoreHome()
      }
    },

    handleProductTabClick(category) {
      let capitalizedCategory = category.charAt(0).toUpperCase() + category.slice(1);
      this.trackProductNavClick(capitalizedCategory);
      this.$emit('clicked', category);
      this.activeProductTab = category;
    },

    handleBackButtonClick() {
      this.trackProductNavClick('Back');
      this.handleBackEvent();
    },

    trackProductNavClick(category) {
      const properties = {
        menuItem: category,
        productKey: this.activeProductInfo.key,
        productName: this.activeProductInfo.name
      }
      this.fireSegmentTrackingWithSfdcSegments("Product Details Menu Item Clicked", this.sfdcSegments, properties);
    },

    handleBuyButtonClick() {
      this.buyButtonFunctionality();
      this.trackBuyButtonClick();
    },

    trackBuyButtonClick() {
      const properties = {
        buyButtonLocation: 'Product details menu',
      }
      this.fireSegmentTrackingWithSfdcSegments("Buy Button Clicked", this.sfdcSegments, properties);
    },
  },


};
</script>

<style lang="scss" scoped>
select {
  padding: 5px 10px;
  border: 1px solid #0184fb;
  position: relative;
}
.dropdown--mobile:after {
  content: "";
  position: absolute;
  right: 30px;
  top: 18px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #0184fb;
}
.hover-link {
  font-weight: 500;
  padding: 6px 16px;
}
.hover-link:hover {
  color: #0384FB;
}
.active {
  background: #F2F7FF;
  border-radius: 37px;
  font-weight: 600;
}
.active:hover {
  background: #F2F7FF;
  opacity: 0.6;
}
.buy-link {
  padding: 6px 25px;
  font-weight: 700;
}
@media (min-width: 736px) {
  .buy-link {
    padding: 12px 40px;
    font-weight: 700;
  }
  .back-hover {
    border-radius: 37px;
    padding: 11px 17px;
  }
  .hover-link {
    padding: 11px 16px;
  }
}

.back-hover:active {
  background: #F2F7FF;
}

.no-pad {
  padding-top: 0;
  padding-bottom: 0;
}

.back-hover:hover p {
  color: #0384FB;
}

.roboto {
  font-family: 'Roboto';
}

.back-hover:hover svg path {
  fill: #0384FB;
}

.mobile-hide {
  display: none;
}

@media (min-width: 736px) {
  .mobile-hide {
    display: flex;
  }
}
</style>